import React, { useRef } from 'react';
import { useState } from 'react'
import { chevron_right_green, chevron_right, cloud } from '../../Images/Icons';
import { View } from '../../Components';
import StatisticCard from './StatisticCard';
import EnvironmentalCard from './EnvironmentalCard';
import GridEnergyHybrid from './GridEnergyHybrid';
import { useNavigate, useOutletContext,useParams } from 'react-router-dom';
import { useEffect } from 'react';
import css from './HomePage.module.scss'
import 'react-spring-bottom-sheet/dist/style.css';
import { useSelector, useDispatch } from 'react-redux';
import PlantManagement from './PlantManagement';
import GridEnergyOnGrid from './GridEnergyOnGrid';
import GridEnergyOffGrid from './GridEnergyOffGrid';
import GridEnergyBusiness from './GridEnergyBusiness';
import CoachMarkStep2 from '../../Components/CoachMark/Step2';
import CoachMarkStep3 from '../../Components/CoachMark/Step3';
import CoachMarkStep5 from '../../Components/CoachMark/Step5';
import CoachMarkStep6 from '../../Components/CoachMark/Step6';
import CoachMarkStep7 from '../../Components/CoachMark/Step7';
import CoachMarkStep4 from '../../Components/CoachMark/Step4';
import PlantManagementCoachMark from './PlantManagementCoachMark';
import CoachMarkStep9 from '../../Components/CoachMark/Step9';
import CoachMarkStep10 from '../../Components/CoachMark/Step10';
import { nextStep, backStep } from "../../Var/CoachmarkVar";
import GridEnergyHybridCoachmark from './GridEnergyHybridCoachmark';
import { triangle } from '../../Images/Icons';
import { DoChangeStatusCoachMark, GetDataEnvirontment, GetDataStation, GetDataStatistic, GetLonLat, GetWeather } from '../../Services/HomeServices';
import { set } from 'date-fns';

const HomePage = () => {
    
    const navigation = useNavigate();
    const coachmark = localStorage.getItem("coachmark");
    const user_id = localStorage.getItem("user_id");
    const refresh_token = localStorage.getItem("refresh_token");
    const station_get = localStorage.getItem("station_get");
    const station_id_decoded = atob(station_get);
    
    // console.log('Station disini:',station_id_decoded)


    const Step = useSelector(state => state.Step)
    const dispatch = useDispatch();
    const { id } = useParams();
    const [showBottomSheet, hideBottomSheet] = useOutletContext();
    const [dataStation, setDataStation] = useState(null);
    const [dataStatus, setDataStatus] = useState(null);
    const [dataStatistic, setDataStatistic] = useState(null);
    const [dataWeather, setDataWeather] = useState(null);
    const [dataEnv, setDataEnv] = useState(null);
    const [data_user, setdata_user] = useState(null);
    const [showPopup, setShowPopup] = useState(false);


    const [state, setNewState] = useState({
        showPoup: false,
    });
    

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    const onProfileDetail = () => {
        navigation('/profile/detail');
    }

    const onSelectPlant = (plant) => () => {
    }

    const onChangePlant = () => {
        hideBottomSheet();
    }

    const onCheckChange = e => {} 


    const onPlantManagement = () => { 
        // alert(step)
        if((Step.coachmark == 3 || Step.coachmark == 5 || Step.coachmark == 9 || Step.coachmark == 10)) {
            showBottomSheet('Plant Management', <PlantManagementCoachMark onSelectPlant={onSelectPlant} onChangePlant={onChangePlant} onCheckChange={onCheckChange} status = {dataStatus} />, 'white');
        }else{
            showBottomSheet('Plant Management', <PlantManagement onSelectPlant={onSelectPlant} onChangePlant={onChangePlant} onCheckChange={onCheckChange} status = {dataStatus}/>, 'white');
        }
    } 

    async function changeStatusCoachMark(){
        try {
            const result = await DoChangeStatusCoachMark(user_id);
            console.log('result', result)
            window.location.reload();

        } catch (error) {
          console.error('Error fetching dataStation:', error);
        }
    }

    const energySectionRef = useRef(null);
    const energyHeaderRef = useRef(null);
    const energyEnvRef = useRef(null);
    
    const doNextStep = () => {
        if(Step.coachmark == 3){
            onPlantManagement()
        }else if(Step.coachmark == 4){
            energySectionRef.current.scrollIntoView({ behavior: 'smooth' });
            hideBottomSheet();
        }else if(Step.coachmark == 6){
            energyEnvRef.current.scrollIntoView({ behavior: 'smooth'});
            hideBottomSheet();
        }else if(Step.coachmark == 7){
            energySectionRef.current.scrollIntoView({ behavior: 'smooth' });
            hideBottomSheet();
        }else if(Step.coachmark == 9){
            onPlantManagement();
        }else if(Step.coachmark == 10){
            hideBottomSheet();
            changeStatusCoachMark()

        }

        dispatch(
            nextStep(1)
        )
    };    
    const doBackStep = () => {
        if(Step.coachmark == 4){
            energyHeaderRef.current.scrollIntoView({ behavior: 'smooth'});
            hideBottomSheet();
        }else if(Step.coachmark == 5){
            energyHeaderRef.current.scrollIntoView({ behavior: 'smooth'});
            onPlantManagement();
        }else if(Step.coachmark == 6){
            hideBottomSheet();
        }else if(Step.coachmark == 7){
            energySectionRef.current.scrollIntoView({ behavior: 'smooth' });
            hideBottomSheet();
        }else if(Step.coachmark == 10){
            hideBottomSheet();
        }

        dispatch(
            backStep(1)
        )
    };
    
    const { showPoup } = state;


    async function GetDataAll() {
        // console.log('station_get', atob(station_get));
        // return false;
        const station = JSON.parse(localStorage.getItem('station'));
        // console.log(station)
        if(station){
            const data_user2 = station.filter(stat => stat.station_code === (station_id_decoded));
            // console.log(data_user2)
            setdata_user(data_user2);
        }
        try {
            const resultStation = await GetDataStation(station_get);
            if(resultStation.data.return.pv.status != 'online'){
                setShowPopup(true)
                setDataStatus('Trouble');
            }else{
                setDataStatus('online');
            }
            setDataStation(resultStation.data); 

            const resultEnv = await GetDataEnvirontment(station_get);
            setDataEnv(resultEnv.data);
            
            const resultStatistic = await GetDataStatistic(station_get);
            setDataStatistic(resultStatistic.data.return);

            const getLonLat = await GetLonLat(user_id);
            
            var data = new FormData();
            data.append("lat", getLonLat.data.latitude);
            data.append("lon", getLonLat.data.longitude);

            const getWeather = await GetWeather(data);
            setDataWeather(getWeather.data.data.main)
        } catch (error) {
          console.error('Error fetching dataStation:', error);
        }
    }

    

    
    useEffect(() => {
        
        if(!refresh_token){
            navigation('/login');
        }

        GetDataAll()
        const intervalId = setInterval(GetDataAll, 5 * 60 * 1000);
        if(Step.coachmark == 7){
            energyEnvRef.current.scrollIntoView({ behavior: 'smooth'});
            hideBottomSheet();            
        }
        
        // alert(user_id)
        return () => clearInterval(intervalId);

    }, []);
    
    // console.log
    
    if (!dataStation || !dataStatistic || !dataEnv) {
        return <div className='loading-state'>
            
            <div className='loader-z'></div>
        </div>;
    }
    
    
    return (
        <div>   
            {Step.coachmark == 2 && coachmark == 'false' &&  <CoachMarkStep2 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 3 && coachmark == 'false' &&  <CoachMarkStep3 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 4 && coachmark == 'false' &&  <CoachMarkStep4 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 5 && coachmark == 'false' &&  <CoachMarkStep5 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 6 && coachmark == 'false' &&  <CoachMarkStep6 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 7 && coachmark == 'false' &&  <CoachMarkStep7 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 9 && coachmark == 'false' &&  <CoachMarkStep9 next={doNextStep} prev={doBackStep}/>}
            {Step.coachmark == 10 && coachmark == 'false' &&  <CoachMarkStep10 next={doNextStep} prev={doBackStep}/>}
            {
                id == 4 ?             
                <div className={ `mainHeader  ${css.dark_header}`} id="header" >
                    <div onClick={onPlantManagement} className={css.content_header}>
                        <span>Plant Management</span>
                        <div><img src={chevron_right_green} style={{ marginRight: 10 }} /></div>
                    </div> 
                </div>
                : 
                
                <div className={Step.coachmark == 10 ? `mainHeader  ${css.green_header_10}` : `mainHeader  ${css.green_header}` } id="header">
                    <div onClick={onPlantManagement} className={css.content_header}>
                        <span>Plant Management</span>
                        <div><img src={chevron_right} style={{ marginRight: 10 }} /></div>
                    </div> 
                </div>
            }

            {showPopup && 
                <>
                    <div className={css.popup_wrap} onClick={() => setShowPopup(false)}>
                    <div className={css.content_popup}>          
                        <i class="fi fi-rr-cross-small" onClick={() => setShowPopup(false)}></i>
                        <b style={{marginTop:-10}}>⚠️</b><br/>
                        <p style={{marginTop:-20}}>We've detected an alarm at your plant. For help, contact our professional team at <u><a href="mailto:maintenance.energy@modena.com">maintenance.energy@modena.com</a></u> We'll respond within 24 hours. </p>
                    </div> 
                    </div>
                </>
            }
            <div className={css.wrapper_home}>
            <div ref={energyHeaderRef} style={{height:10, width:10, marginTop:'-20px', marginBottom:'20px', background:'red',position:'relative', top:'-100px'}} ></div>
                <View justifyContent="space-between">
                    <div onClick={onProfileDetail} className={css.profile_info} style={{ cursor: 'pointer', background: '#dedede' }}>
                        <div className={css.profile_initial}>P</div>
                        {data_user &&
                            <View alignItems="start" flexDirection="column" style={{ margin: '0 8px' }}>
                                <label>{data_user[0].station_name.length > 15 ? `${data_user[0].station_name.slice(0, 15)}...` : data_user[0].station_name}</label>
                                <div className={css.detail_profile}>
                                    <span>{data_user[0].power_kwp} kWp</span>
                                    <i className='fi-rr-angle-small-right' ></i>
                                </div>
                            </View>
                        }
                    </div>
                    <div className={css.weather} >
                        <div className={css.weather_value}>
                            <img src={cloud} />
                            {dataWeather && 
                                <span>{dataWeather.temp_min.toFixed(0)}°C ~ {dataWeather.temp_max.toFixed(0)}°C</span>
                            }
                        </div>
                        
                        {dataStatus == 'online' ? 
                            <div className={`${css.weather_status} ${css.status_normal}`}>
                                <span>
                                    <img src="/monitoring/assets/Check.svg" />
                                    {dataStatus}
                                </span>
                            </div>
                        : 
                            <div className={`${css.weather_status} ${css.status_danger}`}>
                                <span>
                                    {dataStatus}
                                </span>
                            </div>
                        } 
                        
                    </div>
                </View>
                {/* Grid Energy */}
                <div id='energy' ref={energySectionRef}>
                    {
                        dataStation.return.deviceType == 'Hybrid' ? <GridEnergyHybrid data = {dataStation} status = {dataStatus} /> : 
                        dataStation.return.deviceType == 'Ongrid' ? <GridEnergyOnGrid data = {dataStation} status = {dataStatus}/> : 
                        dataStation.return.deviceType == 'Offgrid' ? <GridEnergyOffGrid data = {dataStation} status = {dataStatus}/> : 
                        dataStation.return.deviceType == 'Business' ? <GridEnergyBusiness data = {dataStation} status = {dataStatus}/> : 
                        <GridEnergyHybridCoachmark/>
                    }
                </div>
                { /* Card Statistic */}
                <StatisticCard data = {dataStatistic} /> 
                
                { /* Environmental Benefits */}
                <EnvironmentalCard dataEnv = {dataEnv}  />
                <div ref={energyEnvRef}>
                    <div style={{ height: 50, width: '100%' }}></div>
                </div>
            </div>
            {showPoup && <>
                <div style={{
                    width: 300, height: 120, position: 'absolute', top: 130, right: 10, background: '#2C313A', borderRadius: 12, zIndex: 1000,
                    fontSize: 12, fontWeight: 400, color: '#FAFAFA', padding: 12
                }}>
                    <img src="/monitoring/assets/bmkg.png" style={{ float:'left' }}  />

                    <p style={{ float:'left', width:230, paddingLeft:10 }}><b>Source by BMKG</b>:<br />
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>

                </div>
                <div style={{ position: 'absolute', top: 120, right: 10 }}><img src={triangle} alt="" style={{ width: 36, height: 24 }} /></div>

            </>}
        </div>
    )
}

export default HomePage